import { Backdrop, Flex, Text } from 'components'

export default function InfoPage() {
  return (
    <Backdrop flex="auto" overflow="hidden">
      <Flex
        mx={{ base: 0, sm: 7 }}
        gap={2}
        flex="auto"
        mb={2}
        p={{ base: 4, sm: 0 }}
        pt={{ base: `calc(env(safe-area-inset-top) + 10px)`, sm: 0 }}
        pb={{ base: `calc(env(safe-area-inset-bottom) + 35px)`, sm: 0 }}
      >
        <Flex gap={3} direction="column" p={2} pt={10} textAlign="center">
          <Text textStyle="h2">Welcome to Entevate's Event Portal</Text>
          <Text textStyle="bodySmall">
            Please use the QR code provided at the event to get to correct page!
          </Text>
        </Flex>
      </Flex>
    </Backdrop>
  )
}
